import { render, staticRenderFns } from "./ShiftsAddEdit.vue?vue&type=template&id=140010b6&"
import script from "./ShiftsAddEdit.vue?vue&type=script&lang=ts&"
export * from "./ShiftsAddEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports